import {
  AttributeDisplayConfig,
  CategoryConfigFactory,
  massConfig,
  NumericDiff,
} from "components/search/input/DifferencePanel/common";
import { PhysicalParameters } from "store/api/generatedApi";

export const PhysicalParametersConfigFactory: CategoryConfigFactory<
  PhysicalParameters
> = (utils) => {
  const { t, formatNumber2DPFixed } = utils;
  const mass = massConfig(utils);
  const fractionConfig: Omit<
    AttributeDisplayConfig<number | null | undefined>,
    "title"
  > = {
    renderDiff: ({ updatedVal, previousVal }) => (
      <NumericDiff
        previous={(previousVal ?? 0) * 100}
        updated={(updatedVal ?? 0) * 100}
        suffix="%"
        format={formatNumber2DPFixed}
      />
    ),
    format: (val) => `${formatNumber2DPFixed(val * 100)}%`,
  };
  const countConfig: Omit<
    AttributeDisplayConfig<number | null | undefined>,
    "title"
  > = {
    renderDiff: ({ updatedVal, previousVal }) => (
      <NumericDiff
        previous={previousVal ?? 0}
        updated={updatedVal ?? 0}
        format={formatNumber2DPFixed}
      />
    ),
    format: (val) => formatNumber2DPFixed(val),
  };
  return {
    target_tapped_mass_lower: {
      title: t("targetTappedMassLower"),
      ...mass,
    },
    target_tapped_mass_upper: {
      title: t("targetTappedMassUpper"),
      ...mass,
    },
    target_charged_mass_lower: {
      title: t("targetChargedMassLower"),
      ...mass,
    },
    target_charged_mass_upper: {
      title: t("targetChargedMassUpper"),
      ...mass,
    },
    tapped_to_billet_yield: {
      title: t("tappedToBilletYield"),
      ...fractionConfig,
    },
    typical_hot_heel_mass: {
      title: t("typicalHotHeelMass"),
      ...mass,
    },
    max_distinct_materials_per_mix: {
      title: t("maxDistinctMaterialsPerMix"),
      ...countConfig,
    },
  };
};
